import React, { Component } from 'react'
import { Card, Row, Col, Container } from 'react-bootstrap';
import { BsTrash, BsPencilSquare } from "react-icons/bs";
import { IconContext } from "react-icons";

export class cardItem extends Component {
    render() {
        const { data } = this.props;
        const { removeitem } = this.props;
        const { modifyitem } = this.props;
        const { index } = this.props;
        return (
            <div>
                <Card border="info" className="m-1" style={{ fontSize: "11px" }}>
                    
                        <Container>
                        <Row>
                            <Col>COD. {data.ID_ITEMS} - {data.DESCRIPCION_ITEM}</Col>
                        </Row>
                        <Row>
                            <Col>Cant: {data.CANTIDAD}</Col>
                            <Col>Vlr: ${data.VALOR_UNI}</Col>
                        </Row>
                        <Row>
                            <Col>Dscto: {data.DESCUENTO}%</Col>
                            <Col>Vlr. Dscto:{data.VALOR_DCTO}</Col>
                        </Row>
                        <Row>
                            <Col>Vlr. Iva:{data.VALOR_IVA}</Col>
                            <Col>Vlr. Total:{data.TOTAL}</Col>
                        </Row>
                        <Row>
                            <Col>
                                <IconContext.Provider value={{ size: "2em" }}>
                                    <BsTrash onClick={() => removeitem(index)} />
                                </IconContext.Provider></Col>
                            <Col>
                                <IconContext.Provider value={{ size: "2em" }}>
                                    <BsPencilSquare onClick={() => modifyitem(index)} />
                                </IconContext.Provider>
                            </Col>
                        </Row>
                        </Container>
                </Card>
            </div>
        )
    }
}

export default cardItem



// WEBPACK FOOTER //
// ./src/components/subcomponent/cardItem.jsx